export function useNativeTabBarContentInset(_reserveNativeTabBarSpace = false) {
  return 0;
}
